import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import pack1 from '../../img/frozen/orka.png';
import pack2 from '../../img/frozen/bottoms.png';
import pack3 from '../../img/frozen/broccli-removebg-preview.png';
import pack4 from '../../img/frozen/fries-removebg-preview.png';
import pack5 from '../../img/frozen/gaulif-removebg-preview.png';
import pack6 from '../../img/frozen/peas-removebg-preview.png';
import pack7 from '../../img/frozen/molokhia-removebg-preview.png';
import pack8 from '../../img/frozen/strawberries.png-removebg-preview.png';
import pack9 from '../../img/frozen/guava-removebg-preview.png';
import pack10 from '../../img/frozen/mango-removebg-preview.png';
import Aos from 'aos'
import 'aos/dist/aos.css'
export default function Frozen() {
  useEffect(() => {
    Aos.init({
      duration: 1000
    })

  }, [])

  return (
    <>

      <div className="container-fluid bg-primary py-5 bg-heroo mb-5">
        <div className="container py-5">
          <div className="row justify-content-start">
            <div className="col-lg-8 text-center text-lg-start">
              <h1 className="display-1 text-white mb-md-4">Frozen Products</h1>
              <Link to="/" className="btn btn-primary py-md-3 px-md-5 me-3">Home</Link>
              <Link className="btn btn-secondary py-md-3 px-md-5">Frozen Products</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Products Start */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="mx-auto text-center mb-5" style={{ maxWidth: '500px' }}>
            <h6 className="text-primary text-uppercase">Products</h6>
            <h1 className="display-5">Our Frozen Products</h1>
          </div>
          <div className="row text-center">

            
            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack4} alt="Organic Vegetable" />
                <h6 className="mb-3">French Fries</h6>
                <Link to='/fries' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>

            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack1} alt="Organic Vegetable" />
                <h6 className="mb-3"> Frozen Okra</h6>
                <Link to='/okra' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>

            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack3} alt="Organic Vegetable" />
                <h6 className="mb-3"> Frozen Broccoli</h6>
                <Link to='/broccoli' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>

            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack7} alt="Organic Vegetable" />
                <h6 className="mb-3"> Egyptian Molokhia (Minced)</h6>
                <Link to='/molokhia' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>

            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack6} alt="Organic Vegetable" />
                <h6 className="mb-3"> Peas with Carrots</h6>
                <Link to='/peas' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>

            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack2} alt="Organic Vegetable" />
                <h6 className="mb-3">Artichoke Bottoms</h6>
                <Link to='/artichoke-bottoms' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>

            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack5} alt="Organic Vegetable" />
                <h6 className="mb-3"> Frozen Cauliflower</h6>
                <Link to='/cauliflower' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>
            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack8} alt="Organic Vegetable" />
                <h6 className="mb-3"> Frozen Strawberries</h6>
                <Link to='/frozen-strawberries' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>
            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack10} alt="Organic Vegetable" />
                <h6 className="mb-3"> Frozen Mango Slices</h6>
                <Link to='/mango' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>
            <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="product-item  bg-white ">
                <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack9} alt="Organic Vegetable" />
                <h6 className="mb-3">Frozen Sliced Guava</h6>
                <Link to='/guava' className='btn btd-primary bg-primary text-light '>details</Link>

              </div>
            </div>

          </div>
        </div>
      </div>
      {/* Products End */}
    </>
  );
}
